// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Images/product.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../Images/galery.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.Home_home-section-one__b8M1x {
  width: 100%;
  height: 85vh;
  background-color: #252626;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-top: -2px;
  box-sizing: border-box;
  overflow-x: hidden;
}

.Home_Navbar-home__Q9jN1 {
  background-color: #252626;
}

.Home_home-section-one__b8M1x iframe {
  margin: auto;
  width: 100%;
  height: 100%;
  border: none;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  pointer-events: none;
}

.Home_home-section-two__uaeT1 {
  margin: auto;
  width: 90%;
}

.Home_paragraph-child-one__otpIz {
  font-family: "Roboto", sans-serif;
  font-weight: 700;
  font-size: 62px;
  line-height: 49px;
  color: #252626;
  margin-top: 150px;
}

.Home_section-two-paragraph__ZGy55 {
  margin: auto;
  width: 80%;
}

.Home_paragraph-child-two__A2vNR {
  font-weight: 700;
  font-size: 64px;
  line-height: 10%;
  color: #4C6D59;
  margin-bottom: 140px;
}

.Home_section-two-contents__E4RYg {
  width: 80%;
  height: 514px;
  display: flex;
  justify-content: space-between;
  margin: auto;
}

.Home_content-one__3vbbW {
  width: 50%;
  height: 100%;
  background-image: url("https://i.imgur.com/IzMCeZN.jpeg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
}

.Home_content-one__3vbbW p {
  color: white;
  font-size: 44px;
  font-weight: 700;
  line-height: 100%;
  position: absolute;
  bottom: 20px;
  left: 40px;
  margin: 0;
  font-family: "Roboto", sans-serif;
}

.Home_content-two__eDohM {
  width: 45%;
  height: 100%;
  background-image: url("https://i.imgur.com/0iVcmHY.jpeg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  position: relative;
}

.Home_content-two__eDohM p {
  color: white;
  font-size: 44px;
  font-weight: 700;
  line-height: 100%;
  position: absolute;
  bottom: 20px;
  left: 40px;
  font-family: "Roboto", sans-serif;
  margin: 0;
}

.Home_uav__DZBG8 {
  width: 80%;
  height: 534px;
  background-image: url("https://i.imgur.com/0ISz24f.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: auto;
  margin-top: 50px;
  position: relative;
  margin-bottom: 150px;
  background-position-y: -70px;
  cursor: pointer;
}

.Home_uav__DZBG8 p {
  color: white;
  font-size: 44px;
  font-weight: 700;
  line-height: 100%;
  position: absolute;
  bottom: 20px;
  left: 40px;
  font-family: "Roboto", sans-serif;
  margin: 0;
}

.Home_product-icon__vbcbV a {
  list-style: none;
  outline: none;
  border: none;
  font-family: "Roboto", sans-serif;
  text-decoration: none;
}

/* ============ RESPONSIVE ============ */
@media (max-width: 1000px) {
  .Home_paragraph-child-one__otpIz,
  .Home_paragraph-child-two__A2vNR,
  .Home_content-one__3vbbW p,
  .Home_content-two__eDohM p,
  .Home_uav__DZBG8 p {
    font-size: 32px;
  }
  .Home_section-two-contents__E4RYg {
    flex-direction: column;
    height: auto;
    gap: 20px;
  }
  .Home_content-one__3vbbW,
  .Home_content-two__eDohM {
    width: 100%;
    height: 250px;
  }
  .Home_home-section-one__b8M1x iframe {
    width: 100%;
    height: 50vh;
  }
  .Home_uav__DZBG8 {
    height: 300px;
  }
  .Home_paragraph-child-one__otpIz,
  .Home_paragraph-child-two__A2vNR {
    font-size: 36px;
    text-align: center;
  }
  .Home_uav__DZBG8 p {
    left: 20px;
    bottom: 10px;
  }
}
.Home_product-section__7MtX2 {
  width: 100%;
  height: 584px;
  display: flex;
}

.Home_product-icons-section__bG8zw {
  max-width: 800px;
  width: 100%;
  height: 100%;
  display: flex;
}

.Home_product-icon__vbcbV {
  width: 115px;
  height: 101px;
  left: 362px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  margin: auto;
  padding-top: 70px;
}

.Home_galery-icon__Ff9J7 {
  width: 115px;
  height: 101px;
  left: 362px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  margin: auto;
  padding-top: 70px;
}

.Home_aw5-section__qd4qk {
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
}

.Home_aw-5-image__11DYA {
  width: 60%;
  height: 100%;
  background-image: url("https://i.imgur.com/wBIYRT4.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right center;
}

.Home_product-icon__vbcbV p {
  color: #4C6D59;
  font-weight: 700;
  font-size: 36px;
}

.Home_galery-icon__Ff9J7 p {
  color: #4C6D59;
  font-weight: 700;
  font-size: 36px;
}

.Home_loading-container__4HddT {
  width: 100vw;
  height: 100vh;
  background: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.Home_loading-video__X3yWd {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 1000px) {
  .Home_product-section__7MtX2 {
    flex-direction: column; /* Flex ուղղությունը դարձնում ենք vertical */
    align-items: center; /* կենտրոնացնում ենք child-երը */
    height: auto; /* բարձրությունը թողնենք auto */
  }
  .Home_product-icons-section__bG8zw {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: auto;
    gap: 20px; /* icon-ների միջև տարածություն */
    margin-bottom: 20px;
  }
  .Home_product-icon__vbcbV,
  .Home_galery-icon__Ff9J7 {
    width: 75px;
    height: 65px;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 0;
    margin-bottom: 50px;
    margin-top: 40px;
  }
  .Home_product-icon__vbcbV p,
  .Home_galery-icon__Ff9J7 p {
    font-size: 24px;
    text-align: center;
    margin-top: 150px;
  }
  .Home_aw5-section__qd4qk {
    width: 100%;
    justify-content: center;
  }
  .Home_aw-5-image__11DYA {
    width: 80%;
    height: 300px;
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
  }
}
@media (max-width: 600px) {
  .Home_paragraph-child-one__otpIz,
  .Home_paragraph-child-two__A2vNR,
  .Home_content-one__3vbbW p,
  .Home_content-two__eDohM p,
  .Home_uav__DZBG8 p {
    font-size: 20px;
  }
  .Home_uav__DZBG8 {
    height: 200px;
  }
  .Home_content-one__3vbbW,
  .Home_content-two__eDohM {
    height: 180px;
  }
}
@media (max-width: 780px) {
  .Home_home-section-one__b8M1x iframe {
    width: 95%;
    height: 50vh;
  }
  .Home_home-section-one__b8M1x {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .Home_paragraph-child-one__otpIz,
  .Home_paragraph-child-two__A2vNR {
    font-size: 20px;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 80px;
  }
  .Home_section-two-contents__E4RYg {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }
  .Home_content-one__3vbbW,
  .Home_content-two__eDohM {
    width: 95%;
    height: 200px;
  }
  .Home_content-one__3vbbW p,
  .Home_content-two__eDohM p {
    font-size: 20px;
    left: 20px;
    bottom: 10px;
  }
  .Home_uav__DZBG8 {
    width: 76%;
    height: 200px;
    margin: 30px auto 50px auto;
    background-position-y: 1px;
  }
  .Home_pro__cDTPy .Home_uav__DZBG8 p {
    font-size: 28px;
    left: 20px;
    bottom: 10px;
  }
}
@media (max-width: 360px) {
  .Home_paragraph-child-one__otpIz,
  .Home_paragraph-child-two__A2vNR {
    font-size: 18px;
    text-align: center;
    margin-top: 80px;
    margin-bottom: 80px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Home/Home.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAEF;;AACA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;AAEF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,mBAAA;EACA,oBAAA;AACF;;AAIA;EACE,YAAA;EACA,UAAA;AADF;;AAIA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AADF;;AAIA;EAKE,YAAA;EACA,UAAA;AALF;;AAgBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAbF;;AAgBA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AAbF;;AAgBA;EACE,UAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AAbF;;AAgBA;EACE,UAAA;EACA,YAAA;EACA,yDAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;AAbF;;AAgBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iCAAA;EACA,SAAA;AAbF;;AAgBA;EACE,UAAA;EACA,aAAA;EACA,wDAAA;EACE,sBAAA;EACF,2BAAA;EACA,4BAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,eAAA;AAbF;;AAiBA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,iCAAA;EACA,SAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;EACA,qBAAA;AAdF;;AAiBA,yCAAA;AAEA;EACE;;;;;IAKE,eAAA;EAfF;EAkBA;IACE,sBAAA;IACA,YAAA;IACA,SAAA;EAhBF;EAmBA;;IAEE,WAAA;IACA,aAAA;EAjBF;EAoBA;IACE,WAAA;IACA,YAAA;EAlBF;EAqBA;IACE,aAAA;EAnBF;EA0BA;;IAEE,eAAA;IACA,kBAAA;EAxBF;EA2BA;IACE,UAAA;IACA,YAAA;EAzBF;AACF;AA6BA;EACE,WAAA;EACA,aAAA;EACA,aAAA;AA3BF;;AAgCA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AA7BF;;AAkCA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AA/BF;;AAqCA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,yDAAA;EACA,wBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAlCF;;AAsCA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;AAnCF;;AAwCA;EACE,UAAA;EACA,YAAA;EACA,wDAAA;EACA,wBAAA;EACA,4BAAA;EACA,iCAAA;AArCF;;AAwCA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AArCF;;AAyCA;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAtCF;;AAyCA;EACE,YAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtCF;;AA0CA;EACE;IACE,sBAAA,EAAA,4CAAA;IACA,mBAAA,EAAA,gCAAA;IACA,YAAA,EAAA,+BAAA;EAvCF;EA0CA;IACE,sBAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,YAAA;IACA,SAAA,EAAA,gCAAA;IACA,mBAAA;EAxCF;EAgDA;;IAEE,WAAA;IACA,YAAA;IACA,wBAAA;IACA,4BAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,cAAA;IACA,mBAAA;IACA,gBAAA;EA9CF;EAiDA;;IAEE,eAAA;IACA,kBAAA;IACA,iBAAA;EA/CF;EAkDA;IACE,WAAA;IACA,uBAAA;EAhDF;EAmDA;IACE,UAAA;IACA,aAAA;IACA,2BAAA;IACA,wBAAA;IACA,4BAAA;EAjDF;AACF;AAqDA;EACE;;;;;IAKE,eAAA;EAnDF;EAsDA;IACE,aAAA;EApDF;EAyDA;;IAEE,aAAA;EAvDF;AACF;AA0DA;EACE;IACE,UAAA;IACA,YAAA;EAxDF;EA2DA;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,WAAA;EAzDF;EA4DA;;IAEE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EA1DF;EA8DA;IACE,sBAAA;IACA,mBAAA;IACA,SAAA;EA5DF;EA+DA;;IAEE,UAAA;IACA,aAAA;EA7DF;EAgEA;;IAEE,eAAA;IACA,UAAA;IACA,YAAA;EA9DF;EAiEA;IACE,UAAA;IACA,aAAA;IAEA,2BAAA;IAEA,0BAAA;EAjEF;EAoEA;IAGE,eAAA;IACA,UAAA;IACA,YAAA;EApEF;AACF;AAwEA;EACE;;IAEE,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,mBAAA;EAtEF;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.home-section-one {\n  width: 100%;\n  height: 85vh;\n  background-color: #252626;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  margin-top: -2px;\n  box-sizing: border-box;\n  overflow-x: hidden;\n\n}\n\n.Navbar-home {\n  background-color: #252626;\n}\n\n.home-section-one iframe {\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  border: none;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  pointer-events: none;\n\n\n}\n\n.home-section-two {\n  margin: auto;\n  width: 90%;\n}\n\n.paragraph-child-one {\n  font-family: 'Roboto', sans-serif;\n  font-weight: 700;\n  font-size: 62px;\n  line-height: 49px;\n  color: #252626;\n  margin-top: 150px;\n}\n\n.section-two-paragraph {\n  //margin-left: 170px;\n  //background-color: red;\n  //max-width: 1150px;\n  //height: 100%;\n  margin: auto;\n  width: 80%;\n  //padding-left: 160px;\n}\n\n\n\n\n\n\n\n\n.paragraph-child-two {\n  font-weight: 700;\n  font-size: 64px;\n  line-height: 10%;\n  color: #4C6D59;\n  margin-bottom: 140px;\n}\n\n.section-two-contents {\n  width: 80%;\n  height: 514px;\n  display: flex;\n  justify-content: space-between;\n  margin: auto;\n}\n\n.content-one {\n  width: 50%;\n  height: 100%;\n  background-image: url(\"https://i.imgur.com/IzMCeZN.jpeg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  position: relative;\n}\n\n.content-one p {\n  color: white;\n  font-size: 44px;\n  font-weight: 700;\n  line-height: 100%;\n  position: absolute;\n  bottom: 20px;\n  left: 40px;\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\n.content-two {\n  width: 45%;\n  height: 100%;\n  background-image: url(\"https://i.imgur.com/0iVcmHY.jpeg\");\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  cursor: pointer;\n  position: relative;\n}\n\n.content-two p {\n  color: white;\n  font-size: 44px;\n  font-weight: 700;\n  line-height: 100%;\n  position: absolute;\n  bottom: 20px;\n  left: 40px;\n  font-family: 'Roboto', sans-serif;\n  margin: 0;\n}\n\n.uav {\n  width: 80%;\n  height: 534px;\n  background-image: url(\"https://i.imgur.com/0ISz24f.png\");\n    background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  margin: auto;\n  margin-top: 50px;\n  position: relative;\n  margin-bottom: 150px;\n  background-position-y: -70px;\n  cursor: pointer;\n\n}\n\n.uav p {\n  color: white;\n  font-size: 44px;\n  font-weight: 700;\n  line-height: 100%;\n  position: absolute;\n  bottom: 20px;\n  left: 40px;\n  font-family: 'Roboto', sans-serif;\n  margin: 0;\n}\n\n.product-icon a {\n  list-style: none;\n  outline: none;\n  border: none;\n  font-family: 'Roboto', sans-serif;\n  text-decoration: none;\n}\n\n/* ============ RESPONSIVE ============ */\n\n@media (max-width: 1000px) {\n  .paragraph-child-one,\n  .paragraph-child-two,\n  .content-one p,\n  .content-two p,\n  .uav p {\n    font-size: 32px;\n  }\n\n  .section-two-contents {\n    flex-direction: column;\n    height: auto;\n    gap: 20px;\n  }\n\n  .content-one,\n  .content-two {\n    width: 100%;\n    height: 250px;\n  }\n\n  .home-section-one iframe {\n    width: 100%;\n    height: 50vh;\n  }\n\n  .uav {\n    height: 300px;\n  }\n\n  .home-section-one {\n    //height: auto;\n  }\n\n  .paragraph-child-one,\n  .paragraph-child-two {\n    font-size: 36px;\n    text-align: center;\n  }\n\n  .uav p {\n    left: 20px;\n    bottom: 10px;\n  }\n}\n\n\n.product-section {\n  width: 100%;\n  height: 584px;\n  display: flex;\n\n}\n\n\n.product-icons-section {\n  max-width: 800px;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n}\n\n\n.product-icon {\n  width: 115px;\n  height: 101px;\n  left: 362px;\n  background-image: url(\"../Images/product.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  margin: auto;\n  padding-top: 70px;\n\n\n}\n\n\n.galery-icon {\n  width: 115px;\n  height: 101px;\n  left: 362px;\n  background-image: url(\"../Images/galery.svg\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  display: flex;\n  margin: auto;\n  padding-top: 70px;\n\n}\n\n.aw5-section {\n  width: 60%;\n  height: 100%;\n  display: flex;\n  justify-content: flex-end;\n\n\n}\n\n.aw-5-image {\n  width: 60%;\n  height: 100%;\n  background-image: url(\"https://i.imgur.com/wBIYRT4.png\");\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: right center;\n}\n\n.product-icon p {\n  color: #4C6D59;\n  font-weight: 700;\n  font-size: 36px;\n\n}\n\n.galery-icon p {\n  color: #4C6D59;\n  font-weight: 700;\n  font-size: 36px;\n}\n\n.loading-container {\n  width: 100vw;\n  height: 100vh;\n  background: black;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n}\n\n.loading-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n@media (max-width: 1000px) {\n  .product-section {\n    flex-direction: column; /* Flex ուղղությունը դարձնում ենք vertical */\n    align-items: center; /* կենտրոնացնում ենք child-երը */\n    height: auto; /* բարձրությունը թողնենք auto */\n  }\n\n  .product-icons-section {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: auto;\n    gap: 20px; /* icon-ների միջև տարածություն */\n    margin-bottom: 20px;\n  }\n\n  .uav{\n\n  }\n\n\n  .product-icon,\n  .galery-icon {\n    width: 75px;\n    height: 65px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-top: 0;\n    margin-bottom: 50px;\n    margin-top: 40px;\n  }\n\n  .product-icon p,\n  .galery-icon p {\n    font-size: 24px;\n    text-align: center;\n    margin-top: 150px;\n  }\n\n  .aw5-section {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .aw-5-image {\n    width: 80%;\n    height: 300px;\n    background-position: center;\n    background-size: contain;\n    background-repeat: no-repeat;\n  }\n}\n\n\n@media (max-width: 600px) {\n  .paragraph-child-one,\n  .paragraph-child-two,\n  .content-one p,\n  .content-two p,\n  .uav p {\n    font-size: 20px;\n  }\n\n  .uav {\n    height: 200px;\n\n\n  }\n\n  .content-one,\n  .content-two {\n    height: 180px;\n  }\n}\n\n@media (max-width: 780px) {\n  .home-section-one iframe {\n    width: 95%;\n    height: 50vh;\n  }\n\n  .home-section-one {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n  }\n\n  .paragraph-child-one,\n  .paragraph-child-two {\n    font-size: 20px;\n    text-align: center;\n    margin-top: 80px;\n    margin-bottom: 80px;\n    //max-width: 100%;\n  }\n\n  .section-two-contents {\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .content-one,\n  .content-two {\n    width: 95%;\n    height: 200px;\n  }\n\n  .content-one p,\n  .content-two p {\n    font-size: 20px;\n    left: 20px;\n    bottom: 10px;\n  }\n\n  .uav {\n    width: 76%;\n    height: 200px;\n    //margin-bottom: 100px;\n    margin: 30px auto 50px auto;\n   //background-position-x: -250px;\n    background-position-y: 1px;\n  }\n\n  .pro\n\n  .uav p {\n    font-size: 28px;\n    left: 20px;\n    bottom: 10px;\n  }\n}\n\n\n@media (max-width: 360px) {\n  .paragraph-child-one,\n  .paragraph-child-two {\n    font-size: 18px;\n    text-align: center;\n    margin-top: 80px;\n    margin-bottom: 80px;\n    //max-width: 300px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-section-one": `Home_home-section-one__b8M1x`,
	"Navbar-home": `Home_Navbar-home__Q9jN1`,
	"home-section-two": `Home_home-section-two__uaeT1`,
	"paragraph-child-one": `Home_paragraph-child-one__otpIz`,
	"section-two-paragraph": `Home_section-two-paragraph__ZGy55`,
	"paragraph-child-two": `Home_paragraph-child-two__A2vNR`,
	"section-two-contents": `Home_section-two-contents__E4RYg`,
	"content-one": `Home_content-one__3vbbW`,
	"content-two": `Home_content-two__eDohM`,
	"uav": `Home_uav__DZBG8`,
	"product-icon": `Home_product-icon__vbcbV`,
	"product-section": `Home_product-section__7MtX2`,
	"product-icons-section": `Home_product-icons-section__bG8zw`,
	"galery-icon": `Home_galery-icon__Ff9J7`,
	"aw5-section": `Home_aw5-section__qd4qk`,
	"aw-5-image": `Home_aw-5-image__11DYA`,
	"loading-container": `Home_loading-container__4HddT`,
	"loading-video": `Home_loading-video__X3yWd`,
	"pro": `Home_pro__cDTPy`
};
export default ___CSS_LOADER_EXPORT___;
